export type OAuth2Config = {
    clientId: string,
    issuer: string,
    scopes: string[],
    pkce: boolean,
};
export type NamedOAuth2Config = OAuth2Config & {
    name: string,
};
export type CurrentUserData = {
    guid: string,
    username: string,
    email: string,
    firstName: string,
    lastName: string,
    role: AvailableRole,
    canManageProviderUser: boolean,
    canManageClientReport: boolean,
    canAccessClientPlacement: boolean,
    canAccessClientReport: boolean,
    canAccessProviderMetrics: boolean,
    canAccessRoster: boolean,
    canAccessAuditLog: boolean,
    canAccessContactEdit: boolean,
    canAccessContactRead: boolean,
    enableOfferHours: boolean,
    isProviderSupport: boolean,
    provider: {
        guid: string,
        name: string,
    } | null,

};

export type GlobalSettingData = {
    guid: string;
    settingKey: string;
    settingValue: string;
}

export const AUTH_PDF_FOOTER_SETTING_KEY = 'AUTH_PDF_FOOTER';

export const extractGlobalSetting = (settingKey: string, globalSettings: GlobalSettingData[]) => {
    return globalSettings.find((setting) => setting.settingKey === settingKey)?.settingValue ?? '';
}

export const extractCompositedRoleFromCurrentUser = (currentUser: CurrentUserData | null): AvailableRole[]=> {
    if (!currentUser) {
        return [];
    }
    if (currentUser.role === 'CLIENT_PLACEMENT_DECISION_MAKER_WITH_PROVIDER_SUPPORT')
        return ['CLIENT_PLACEMENT_DECISION_MAKER', 'PROVIDER_SUPPORT'];
    if (currentUser.role === 'CLIENT_PLACEMENT_SPECIALIST_WITH_PROVIDER_SUPPORT')
        return ['CLIENT_PLACEMENT_SPECIALIST', 'PROVIDER_SUPPORT'];
    if (currentUser.role === 'THE_BHPN_ADMIN_WITH_PROVIDER_SUPPORT')
        return ['THE_BHPN_ADMIN', 'PROVIDER_SUPPORT'];
    return [currentUser.role];
};

export type AvailableRole = ClientPlacementRole | UserManagementRole | CompositedRole;
export type ClientPlacementRole = 'CLIENT_PLACEMENT_SPECIALIST' |
    'CLIENT_PLACEMENT_DECISION_MAKER' |
    'PROVIDER_SUPPORT' | 
    'PROVIDER';
export type UserManagementRole = 'THE_BHPN_ADMIN' |
    'PROVIDER_ADMIN' |
    'PROVIDER_SUPPORT' |
    'PROVIDER_MEMBER';
export type CompositedRole = 'CLIENT_PLACEMENT_DECISION_MAKER_WITH_PROVIDER_SUPPORT' | 'CLIENT_PLACEMENT_SPECIALIST_WITH_PROVIDER_SUPPORT' | 'THE_BHPN_ADMIN_WITH_PROVIDER_SUPPORT'; 

export * from './component/CurrentUser';
export * from './component/OktaSecurity';
export * from './component/OktaInitSignIn';
export * from './component/OktaAuthenticatedEnvironment';
export * from './component/PortalSecureRoute';
export * from './component/TokenContext';
export * from './interface/TokenManager';
export * from './manager/OktaTokenManager';
export * from './manager/AzureTokenManager';
